import { useLang } from 'hooks/lang';

import { invoiceControlConfigByCode, calculateProjectTotal } from 'entities';

import { Row, Alert, Column } from 'components/Blocks';
import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { CircleDollarIcon } from 'components/Icons';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

import { formatCurrency } from 'utils/text';

export function MinFee() {
  const { t } = useLang();

  const { project } = useProjectProfile();

  if (!project.minFee) return null;

  const displayValueBelowMin = [
    Number(calculateProjectTotal(project.services)) < Number(project.minFee.value),
    invoiceControlConfigByCode[project.invoice.status].displayMinFeeWarning,
  ].every(Boolean);

  return (
    <Column>
      <PropertyWithIcon
        icon={<CircleDollarIcon />}
        name={t('min-fee')}
        value={
          <Row gap="2">
            <span className="text-success">{project.currency}</span>

            <span className="text-primary">{formatCurrency(project.minFee.value)}</span>
          </Row>
        }
      />

      {displayValueBelowMin && <Alert level="warning">{t('project-value-below-min')}</Alert>}
    </Column>
  );
}
